import Download from "@/components/schooldata/Download";
import Activity from "@/components/Activity";
import MatchingLayout from "@/components/matching/Layout";
import MatchingIndex from "@/components/matching/Index";
import MatchingGroups from "@/components/matching/Groups";
import MatchingClasses from "@/components/matching/Classes";
import MatchingUsers from "@/components/matching/Users";
import OrganisationSchools from "@/components/organisation/Schools";
import ClassroomLayout from "@/components/classroom/Layout";
import Classroom from "@/components/classroom/Index";
import Class from "@/components/classroom/Class";

export default [
    {
		path: "/matching",
		component: MatchingLayout,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: true
		},
		children: [
			{
				name: "matching",
				path: "",
				component: MatchingIndex,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			},
			{
				name: "matching.groups",
				path: "/matching/groups",
				component: MatchingGroups,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			},
			{
				name: "matching.classes",
				path: "/matching/classes",
				component: MatchingClasses,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			},
			{
				name: "matching.users",
				path: "/matching/users",
				component: MatchingUsers,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: true
				}
			}
		]
	},
    {
        name: "schooldata.download",
        path: "/schooldata/download",
        component: Download,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: true
        }
    },
    {
		name: "activity",
		path: "/activity",
		component: Activity,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: true
		}
	},
	{
        name: "organisation.schools",
        path: "/organisation/schools",
        component: OrganisationSchools,
        meta: {
            requiresAuth: true,
            requiresShard: true,
            completedWizard: false
        }
    },
	{
        name:"teams.layout",
		path: "/teams",
		component: ClassroomLayout,
		meta: {
			requiresAuth: true,
			requiresShard: true,
			completedWizard: false
		},
		children: [
			{
				name: "teams",
				path: "/teams",
				component: Classroom,
				meta: {
					requiresAuth: true,
					requiresShard: true,
					completedWizard: false
				},
				children: [
					{
						name: "classrooms.select",
						path: "/teams/:id",
						component: Class,
						meta: {
							requiresAuth: true,
							requiresShard: true,
							completedWizard: false
						}
					}
				]
			}
		]
	},
];

